import { render, staticRenderFns } from "./flashsalelist.vue?vue&type=template&id=69b7105d&"
import script from "./flashsalelist.vue?vue&type=script&lang=js&"
export * from "./flashsalelist.vue?vue&type=script&lang=js&"
import style0 from "./flashsalelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports